import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="bg-white border-t border-slate-100 py-4 px-6 md:px-8 mt-auto w-full no-print"
      role="contentinfo"
      aria-label="Site Footer"
    >
      <div className="max-w-[1400px] mx-auto text-center text-xs md:text-sm font-semibold text-slate-500">
        &copy; {currentYear} CSK Language & Consultancy P. Ltd. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
